export default {
    706: "Token không hợp lệ",
    210: "Client hoặc Secret không hợp lệ",
    711: "Không có quyền truy cập",
    204: "Lỗi server chưa phát hiện được",
    100: "Param không hợp lệ",
    205: "Username hoặc password không đúng",
    206: "User hoặc Device không tìm thấy"
}